// Plain CommonJS so build-time Node scripts (e.g. create-pages.js) can
// require() it without going through the theme's TSX barrel.

const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Case-insensitive equivalent of Gatsby's `eq` filter, serialized to its
// regex syntax (`/pattern/flags`).
const toNameMatchRegex = (name) =>
  name ? `/^${escapeRegex(name.trim())}$/i` : null;

module.exports = {
  escapeRegex,
  toNameMatchRegex,
};
